/* Versus · Conjunto rápido desde las tarjetas de producto */
(function () {
  if (window.vsQuickCombo) return;
  window.vsQuickCombo = true;

  var SHORTS = ['short-f1', 'short-combat-basic', 'short-combat-sb', 'short-bt1'];
  var ORDER = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
  var shortsCache = null;
  var el = null, st = null;

  function money(n) { return '$' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function sized(url, w) { if (!url) return ''; if (url.indexOf('//') === 0) url = 'https:' + url; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function ls(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function saved() {
    var r = null, s = null;
    try { var t = JSON.parse(ls('vsTallas') || 'null'); if (t) { r = t.r || null; s = t.s || null; } } catch (e) {}
    var f = ls('vs-talla');
    return { top: f || r, short: s || f || r };
  }
  function sizesOf(vs) {
    var map = {};
    vs.forEach(function (v) { if (!map[v.s] || (!map[v.s].a && v.a)) map[v.s] = v; });
    var keys = Object.keys(map).sort(function (a, b) {
      var ia = ORDER.indexOf(a), ib = ORDER.indexOf(b);
      return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
    });
    return keys.map(function (k) { return map[k]; });
  }

  function loadShorts() {
    if (shortsCache) return Promise.resolve(shortsCache);
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return Promise.all(SHORTS.map(function (h) {
      return fetch(root + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (list) {
      shortsCache = list.filter(function (p) { return p && p.available; }).map(function (p) {
        var idx = 0;
        (p.options || []).forEach(function (o, i) { var n = (typeof o === 'string' ? o : o.name || '').toLowerCase(); if (n.indexOf('talla') > -1 || n.indexOf('size') > -1) idx = i; });
        return {
          t: p.title, h: p.handle, p: p.price / 100,
          img: sized(p.featured_image || (p.images && p.images[0]), 260),
          v: p.variants.map(function (v) { return { id: v.id, s: (v.options && v.options[idx]) || v.title, a: v.available, p: v.price / 100 }; })
        };
      });
      return shortsCache;
    });
  }

  function build() {
    el = document.createElement('div');
    el.className = 'vs-qc';
    el.hidden = true;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Arma tu conjunto');
    el.innerHTML =
      '<div class="vs-qc__scrim" data-close></div>' +
      '<div class="vs-qc__sheet">' +
        '<div class="vs-qc__grab" aria-hidden="true"></div>' +
        '<div class="vs-qc__head"><div><p class="vs-qc__eyebrow">Arma tu conjunto</p><p class="vs-qc__title" data-title></p></div>' +
          '<button type="button" class="vs-qc__x" data-close aria-label="Cerrar"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button></div>' +
        '<div class="vs-qc__body" data-flow>' +
          '<div class="vs-qc__step" data-s1>' +
            '<div class="vs-qc__top"><img data-top-img alt=""><div><p class="vs-qc__name" data-top-name></p><p class="vs-qc__sub" data-top-sub></p></div></div>' +
            '<p class="vs-qc__k"><i><span>1</span></i><span data-top-k></span></p>' +
            '<div class="vs-qc__sizes" data-top-sizes></div>' +
          '</div>' +
          '<div class="vs-qc__step" data-s2>' +
            '<p class="vs-qc__k"><i><span>2</span></i>Elige tu short</p>' +
            '<div class="vs-qc__shorts" data-shorts></div>' +
          '</div>' +
          '<div class="vs-qc__step" data-s3>' +
            '<p class="vs-qc__k"><i><span>3</span></i><span data-sh-k>Talla del short</span></p>' +
            '<div class="vs-qc__sizes" data-sh-sizes></div>' +
          '</div>' +
          '<p class="vs-qc__msg" data-msg role="status"></p>' +
        '</div>' +
        '<div class="vs-qc__done" data-done hidden>' +
          '<span class="vs-qc__check"><svg width="30" height="30" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
          '<h3>Conjunto agregado</h3><p data-done-txt></p>' +
          '<div class="vs-qc__done-btns"><a href="/checkout" data-checkout>Ir a pagar</a><button type="button" data-close>Seguir viendo</button></div>' +
        '</div>' +
        '<div class="vs-qc__foot" data-foot>' +
          '<div class="vs-qc__price"><small>Conjunto</small><strong data-total></strong><s data-full></s></div>' +
          '<button type="button" class="vs-qc__cta" data-cta disabled></button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(el);

    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) { close(); return; }
      var b = e.target.closest('[data-top-v]');
      if (b && !b.disabled) { st.topV = +b.dataset.topV; paint(); return; }
      var sh = e.target.closest('[data-sh]');
      if (sh) {
        var prevSize = st.shV ? sizeOfV(st.shV) : null;
        st.sh = +sh.dataset.sh;
        var cur = prevSize && findV(st.shorts[st.sh].v, prevSize);
        st.shV = cur && cur.a ? cur.id : preShortV(st.shorts[st.sh]);
        paint(); return;
      }
      var sv = e.target.closest('[data-sh-v]');
      if (sv && !sv.disabled) { st.shV = +sv.dataset.shV; paint(); return; }
      if (e.target.closest('[data-cta]')) add();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el && !el.hidden) close(); });
    window.addEventListener('popstate', function () { if (el && !el.hidden) close(true); });

    /* Arrastrar hacia abajo para cerrar */
    var sheet = el.querySelector('.vs-qc__sheet'), y0 = null, dy = 0;
    sheet.addEventListener('touchstart', function (e) { var body = el.querySelector('[data-flow]'); if (body.contains(e.target) && body.scrollTop > 0) return; y0 = e.touches[0].clientY; dy = 0; }, { passive: true });
    sheet.addEventListener('touchmove', function (e) { if (y0 === null) return; dy = Math.max(0, e.touches[0].clientY - y0); if (dy > 0) { sheet.style.transition = 'none'; sheet.style.transform = 'translateY(' + dy + 'px)'; } }, { passive: true });
    sheet.addEventListener('touchend', function () { if (y0 === null) return; sheet.style.transition = ''; sheet.style.transform = ''; if (dy > 110) close(); y0 = null; });
  }

  function q(s) { return el.querySelector(s); }
  function findV(vs, size) { for (var i = 0; i < vs.length; i++) if (vs[i].s === size && vs[i].a) return vs[i]; for (var j = 0; j < vs.length; j++) if (vs[j].s === size) return vs[j]; return null; }
  function byId(vs, id) { for (var i = 0; i < vs.length; i++) if (vs[i].id === id) return vs[i]; return null; }
  function sizeOfV(id) { var p = st.shorts && st.shorts[st.sh]; var v = p && byId(p.v, id); return v ? v.s : null; }
  function preShortV(p) { var s = st.pref.short; var v = s && findV(p.v, s); return v && v.a ? v.id : null; }

  function open(data) {
    if (!el) build();
    var pref = saved();
    st = { top: data, topV: null, shorts: null, sh: 0, shV: null, pref: pref, busy: false };
    var tv = pref.top && findV(data.v, pref.top);
    if (tv && tv.a) st.topV = tv.id;
    q('[data-title]').textContent = data.l + ' + short';
    q('[data-top-img]').src = data.img || '';
    q('[data-top-name]').textContent = data.t;
    q('[data-top-k]').textContent = 'Talla de tu ' + data.l.toLowerCase();
    q('[data-done]').hidden = true; q('[data-flow]').hidden = false; q('[data-foot]').hidden = false;
    q('[data-msg]').textContent = '';
    q('[data-shorts]').innerHTML = '<span class="vs-qc__sk"></span><span class="vs-qc__sk"></span><span class="vs-qc__sk"></span><span class="vs-qc__sk"></span>';
    q('[data-sh-sizes]').innerHTML = '';
    paint();
    el.hidden = false;
    document.documentElement.classList.add('vs-qc-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-open'); }); });
    try { history.pushState({ vsQc: 1 }, ''); } catch (e) {}
    loadShorts().then(function (list) {
      if (!st || st.top !== data) return;
      st.shorts = list;
      if (!list.length) { q('[data-msg]').textContent = 'Los shorts del conjunto están agotados por ahora.'; q('[data-shorts]').innerHTML = ''; return; }
      var pick = 0;
      for (var i = 0; i < list.length; i++) { if (preShortV(list[i])) { pick = i; break; } }
      st.sh = pick; st.shV = preShortV(list[pick]);
      paint();
    }).catch(function () { q('[data-msg]').textContent = 'No pudimos cargar los shorts. Intenta de nuevo.'; });
  }

  function close(fromPop) {
    if (!el || el.hidden) return;
    el.classList.remove('is-open');
    document.documentElement.classList.remove('vs-qc-lock');
    setTimeout(function () { if (!el.classList.contains('is-open')) el.hidden = true; }, 380);
    if (!fromPop && history.state && history.state.vsQc) { try { history.back(); } catch (e) {} }
  }

  function chips(vs, cur, attr, mine) {
    return sizesOf(vs).map(function (v) {
      return '<button type="button" class="vs-qc__size' + (v.id === cur ? ' is-on' : '') + '" ' + attr + '="' + v.id + '"' + (v.a ? '' : ' disabled aria-label="' + v.s + ' agotada"') + ' aria-pressed="' + (v.id === cur) + '">' + v.s + (mine && v.s === mine && v.a ? '<em>Tu talla</em>' : '') + '</button>';
    }).join('');
  }

  function paint() {
    var d = st.top, tv = st.topV && byId(d.v, st.topV);
    q('[data-top-sizes]').innerHTML = chips(d.v, st.topV, 'data-top-v', st.pref.top);
    q('[data-top-sub]').textContent = money(tv ? tv.p : d.p);
    q('[data-s1]').classList.toggle('is-done', !!tv);

    var p = st.shorts && st.shorts[st.sh];
    if (st.shorts && st.shorts.length) {
      q('[data-shorts]').innerHTML = st.shorts.map(function (s, i) {
        return '<button type="button" class="vs-qc__sh' + (i === st.sh ? ' is-on' : '') + '" data-sh="' + i + '" aria-pressed="' + (i === st.sh) + '"><span class="vs-qc__ring"><img src="' + s.img + '" alt="" loading="lazy" width="84" height="106"></span><span>' + s.t.replace(/^short\s+/i, '') + '</span></button>';
      }).join('');
      q('[data-sh-sizes]').innerHTML = chips(p.v, st.shV, 'data-sh-v', st.pref.short);
      q('[data-sh-k]').textContent = 'Talla del ' + p.t;
    }
    var sv = p && st.shV && byId(p.v, st.shV);
    q('[data-s2]').classList.toggle('is-done', !!p);
    q('[data-s3]').classList.toggle('is-done', !!sv);

    var topP = tv ? tv.p : d.p, shP = sv ? sv.p : (p ? p.p : 0);
    var full = topP + shP, total = full - d.save;
    q('[data-total]').textContent = p ? money(total) : '…';
    q('[data-full]').textContent = p ? 'Por separado ' + money(full) : '';
    var cta = q('[data-cta]');
    if (st.busy) { cta.disabled = true; cta.textContent = 'Agregando…'; }
    else if (!tv) { cta.disabled = true; cta.textContent = 'Elige tu talla'; }
    else if (!sv) { cta.disabled = true; cta.textContent = 'Talla del short'; }
    else { cta.disabled = false; cta.innerHTML = 'Agregar <svg width="18" height="18" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.8"/></svg>'; }
  }

  function add() {
    var d = st.top, tv = byId(d.v, st.topV), p = st.shorts[st.sh], sv = byId(p.v, st.shV);
    if (!tv || !sv || st.busy) return;
    st.busy = true; q('[data-msg]').textContent = ''; paint();
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: tv.id, quantity: 1 }, { id: sv.id, quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        try { localStorage.setItem('vs-talla', tv.s); } catch (e) {}
        st.busy = false;
        q('[data-flow]').hidden = true; q('[data-foot]').hidden = true; q('[data-done]').hidden = false;
        q('[data-done-txt]').textContent = d.t + ' ' + tv.s + ' + ' + p.t + ' ' + sv.s;
        q('[data-checkout]').href = root + 'checkout';
        return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'vs-quick-combo', data: { source: 'vs-quick-combo', itemCount: cart.item_count } } }));
          document.querySelectorAll('.cart-bubble__text-count, [data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
        }).catch(function () {});
      })
      .catch(function (err) {
        st.busy = false;
        q('[data-msg]').textContent = (err && err.description) || 'No se pudo agregar el conjunto. Intenta de nuevo.';
        paint();
      });
  }

  /* Captura el toque antes que la tarjeta (que navega al producto) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-vs-qc]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var data; try { data = JSON.parse(b.getAttribute('data-vs-qc')); } catch (err) { return; }
    open(data);
  }, true);
  /* Precarga los shorts cuando el cliente se acerca al botón */
  document.addEventListener('pointerdown', function (e) { if (e.target.closest && e.target.closest('[data-vs-qc]')) loadShorts().catch(function () {}); }, true);
})();
